import type { User } from 'oidc-client-ts';

export class InMemoryUser {
    constructor() {
        this.set(null);
    }

    set(user: User | null) {
        window.User = user;
    }

    remove() {
        window.User = null;
    }

    get() {
        return window.User as User | null;
    }
}
